import { render } from "./Info.vue?vue&type=template&id=7c6b6636&scoped=true&ts=true&lang=pug"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=7c6b6636&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6b6636"]])

export default __exports__